import { BehaviorSubject } from 'rxjs';
import { UserModel } from '../../definitions/models';
import { UserSchema } from '../../definitions/schemas';
import OrganizationsStore from './OrganizationsStore';
import userPendingActionsStoreInst from './UserPendingActionsStore';
import userRolesStoreInst from './UserRolesStore';

class UserStore {
  private static instance: UserStore;

  private userSubject: BehaviorSubject<UserSchema | undefined>;

  constructor() {
    this.userSubject = new BehaviorSubject<UserSchema | undefined>(undefined);
  }

  public clear() {
    this.userSubject.next(undefined);
    OrganizationsStore.clear();
    userRolesStoreInst.clear();
  }

  public get() {
    return this.userSubject.getValue();
  }

  public getObservable() {
    return this.userSubject.asObservable();
  }

  public isSet() {
    return !!this.userSubject.getValue()?.id;
  }

  /**
   * @note call identifyTools(payload) after setting the user if you
   * want to register the commonly used tools. It's not done this way
   * to avoid coupling the UserStore with the tools' services.
   */
  public set(user: UserSchema) {
    this.userSubject.next(user);
  }

  public setExtended(userExtendedModel: UserSchema) {
    const { userRoles } = userExtendedModel;
    const user = UserModel(userExtendedModel);
    userRolesStoreInst.setExtended(userRoles!);
    this.set(user);
  }

  public static getInstance(): UserStore {
    if (!UserStore.instance) {
      UserStore.instance = new UserStore();
    }
    return UserStore.instance;
  }
}

// Export a singleton instance
const instance = UserStore.getInstance();
Object.freeze(instance);
export default instance;

// Re-export stores
export { userRolesStoreInst as UserRolesStore };
export { userPendingActionsStoreInst as UserPendingActionsStore };
